<template>
  <!-- onboarding page start -->
  <div v-show="Onboarding_action && !show_activebtnPage && !show_noconnection " id="onboardingPage" class="modal">
    <div class="modal-content">

      <!-- header(onboarding page) start -->
      <div class="sc-header">

        <!-- 20191022新增 -->
        <div class="sc-header--back-button" @click="closeOnboarding">
          <div ></div>
        </div>

        <!-- <img src="/static/appicon.png" alt=""> -->
        <div class="sc-header--title">你可以做些什麼?</div>

      </div>
      <!-- header(onboardingPage page) end -->

      <div class="page"  >

        <!------------------------------ jinfm 一刻鯨選 ------------------------------>
        <div class="faqampm-c" ref="faqampm" v-if="this.$route.params.projectId == 'jinfm'">
          <div class="faqampm-q"><img class="img-arrow" src="./assets/iconClass.jpg" alt="">查詢課程內容<span class="faqampm-img"><img src="./assets/iconToparrow.png" alt=""></span>
          </div>
          <div class="faqampm-a">
            <ul class="nav nav--secondary">
                <li class="nav-item"><p>我要找課程</p></li>
                <li class="nav-item"><p>我要找作家</p></li>
                <li class="nav-item"><p>請推薦我課程</p></li>
                <li class="nav-item"><p>請推薦我作家</p></li>
                <li class="nav-item"><p>我想要找蔣勳的課程</p></li>
                <li class="nav-item"><p>我想查詢中年必修課這堂課程</p></li>
            </ul>
          </div>
        </div>
        <div class="faqampm-c" ref="faqampm" v-if="this.$route.params.projectId == 'jinfm'">
          <div class="faqampm-q"><img class="img-arrow" src="./assets/iconQa.jpg" alt="">一般性詢問<span class="faqampm-img"><img src="./assets/iconToparrow.png" alt=""></span>
          </div>
          <div class="faqampm-a">
              <ul class="nav nav--secondary">
                  <li class="nav-item"><p>我忘記密碼了</p></li>
                  <li class="nav-item"><p>我要怎麼下載APP</p></li>
                  <li class="nav-item"><p>我要怎麼購買點數</p></li>
              </ul>
          </div>
        </div>

        <!------------------------------ eip 聯八達 ------------------------------>
        <div class="faqampm-c" ref="faqampm" v-if="this.$route.params.projectId == 'eip'">
          <div class="faqampm-q"  v-show="isEipMobileWeb"><img class="img-arrow" src="./assets/iconClass.jpg" alt="">查詢員工資料<span class="faqampm-img"><img src="./assets/iconToparrow.png" alt=""></span>
          </div>
          <div class="faqampm-a">
            <ul class="nav nav--secondary">
                <li class="nav-item"><p>查找員工資料</p></li>
                <li class="nav-item"><p>我要找某某人</p></li>
                <li class="nav-item"><p>幫我查某某人</p></li>
                <li class="nav-item"><p>某某人是誰</p></li>
                <li class="nav-item"><p>幫我查email</p></li>
            </ul>
          </div>
        </div>

        <div class="faqampm-c" ref="faqampm" v-if="this.$route.params.projectId == 'eip'">
          <div class="faqampm-q"><img class="img-arrow" src="./assets/iconClass.jpg" alt="">查找樓層以及會議室地圖<span class="faqampm-img"><img src="./assets/iconToparrow.png" alt=""></span>
          </div>
          <div class="faqampm-a">
            <ul class="nav nav--secondary">
                <li class="nav-item"><p>公司樓層介紹</p></li>
                <li class="nav-item"><p>幫我找1樓地圖</p></li>
                <li class="nav-item"><p>給我2樓平面圖</p></li>
                <li class="nav-item"><p>105會議室在哪裡</p></li>
                <li class="nav-item"><p>5樓會議室位置</p></li>
            </ul>
          </div>
        </div>

        <div class="faqampm-c" ref="faqampm" v-if="this.$route.params.projectId == 'eip'">
          <div class="faqampm-q"><img class="img-arrow" src="./assets/iconQa.jpg" alt="">一般性詢問<span class="faqampm-img"><img src="./assets/iconToparrow.png" alt=""></span>
          </div>
          <div class="faqampm-a">
              <ul class="nav nav--secondary">
                  <li class="nav-item"><p>公司有什麼福利</p></li>
                  <li class="nav-item"><p>職福會分機是多少</p></li>
                  <li class="nav-item"><p>教育補助金如何申請</p></li>
                  <li class="nav-item"><p>醫藥費補助申請</p></li>
                  <li class="nav-item"><p>電腦設備壞了可以找誰</p></li>
                  <li class="nav-item"><p>想問電子公文問題</p></li>
                  <li class="nav-item"><p>可以教我怎使用嗎</p></li>
              </ul>
          </div>
        </div>

        <!------------------------------ utravel 有行旅 ------------------------------>
        <div class="faqampm-c" ref="faqampm" v-if="this.$route.params.projectId == 'utravel'">
          <div class="faqampm-q"><img class="img-arrow" src="./assets/iconClass.jpg" alt="">查詢課程內容<span class="faqampm-img"><img src="./assets/iconToparrow.png" alt=""></span>
          </div>
          <div class="faqampm-a">
            <ul class="nav nav--secondary">
                <li class="nav-item"><p>我要找課程</p></li>
                <li class="nav-item"><p>我要找作家</p></li>
                <li class="nav-item"><p>請推薦我課程</p></li>
                <li class="nav-item"><p>請推薦我作家</p></li>
                <li class="nav-item"><p>我想要找蔣勳的課程</p></li>
                <li class="nav-item"><p>我想查詢中年必修課這堂課程</p></li>
            </ul>
          </div>
        </div>
        <div class="faqampm-c" ref="faqampm" v-if="this.$route.params.projectId == 'utravel'">
          <div class="faqampm-q"><img class="img-arrow" src="./assets/iconQa.jpg" alt="">一般性詢問<span class="faqampm-img"><img src="./assets/iconToparrow.png" alt=""></span>
          </div>
          <div class="faqampm-a">
              <ul class="nav nav--secondary">
                  <li class="nav-item"><p>我忘記密碼了</p></li>
                  <li class="nav-item"><p>我要怎麼下載APP</p></li>
                  <li class="nav-item"><p>我要怎麼購買點數</p></li>
              </ul>
          </div>
        </div>


        <!------------------------------ udn ------------------------------>
        <div class="faqampm-c" ref="faqampm" v-if="this.$route.params.projectId == 'udn'">
          <div class="faqampm-q"><img class="img-arrow" src="./assets/iconClass.jpg" alt="">查詢新聞<span class="faqampm-img"><img src="./assets/iconToparrow.png" alt=""></span>
          </div>
          <div class="faqampm-a">
            <ul class="nav nav--secondary">
                <li class="nav-item"><p>我想看熱門新聞</p></li>
                <li class="nav-item"><p>最近有什麼新聞</p></li>
                <li class="nav-item"><p>幫我查肺炎的新聞</p></li>
                <li class="nav-item"><p>有哪些新聞分類</p></li>
                <li class="nav-item"><p>給我最新的新聞</p></li>
            </ul>
          </div>
        </div>

        <div class="faqampm-c" ref="faqampm" v-if="this.$route.params.projectId == 'udn'">
          <div class="faqampm-q"><img class="img-arrow" src="./assets/iconClass.jpg" alt="">查詢天氣資訊<span class="faqampm-img"><img src="./assets/iconToparrow.png" alt=""></span>
          </div>
          <div class="faqampm-a">
            <ul class="nav nav--secondary">
                <li class="nav-item"><p>今天天氣如何</p></li>
                <li class="nav-item"><p>台北市的天氣好嗎</p></li>
                <li class="nav-item"><p>查詢台中的空氣品質</p></li>
                <li class="nav-item"><p>今天的紫外線指數有多少</p></li>
                <li class="nav-item"><p>幫我查陽明山的天氣狀況</p></li>
            </ul>
          </div>
        </div>

        <div class="faqampm-c" ref="faqampm" v-if="this.$route.params.projectId == 'udn'">
          <div class="faqampm-q"><img class="img-arrow" src="./assets/iconClass.jpg" alt="">查看星座運勢<span class="faqampm-img"><img src="./assets/iconToparrow.png" alt=""></span>
          </div>
          <div class="faqampm-a">
            <ul class="nav nav--secondary">
                <li class="nav-item"><p>給我這週的星座運勢</p></li>
                <li class="nav-item"><p>水瓶座今天的運勢如何</p></li>
                <li class="nav-item"><p>幫我查雙子座的戀愛運</p></li>
                <li class="nav-item"><p>雙子座今天適合什麼顏色的衣服</p></li>
                <li class="nav-item"><p>我想看唐綺陽的星座週報</p></li>
            </ul>
          </div>
        </div>

        <div class="faqampm-c" ref="faqampm" v-if="this.$route.params.projectId == 'udn'">
          <div class="faqampm-q"><img class="img-arrow" src="./assets/iconClass.jpg" alt="">查詢統一發票中獎資訊<span class="faqampm-img"><img src="./assets/iconToparrow.png" alt=""></span>
          </div>
          <div class="faqampm-a">
            <ul class="nav nav--secondary">
                <li class="nav-item"><p>查找發票中獎號碼</p></li>
                <li class="nav-item"><p>3月的中獎號碼是多少</p></li>
                <li class="nav-item"><p>我想查發票中獎金額</p></li>
            </ul>
          </div>
        </div>

        <div class="faqampm-c" ref="faqampm" v-if="this.$route.params.projectId == 'udn'">
          <div class="faqampm-q"><img class="img-arrow" src="./assets/iconQa.jpg" alt="">一般性詢問<span class="faqampm-img"><img src="./assets/iconToparrow.png" alt=""></span>
          </div>
          <div class="faqampm-a">
            <ul class="nav nav--secondary">
                <li class="nav-item"><p>我可以跟你說什麼</p></li>
                <li class="nav-item"><p>你可以做什麼</p></li>
                <li class="nav-item"><p>你是誰</p></li>
            </ul>
          </div>
        </div>





      </div>

    </div>

  </div>
  <!-- onboarding page end -->
</template>

<script>
import { EventBus } from '../../bus.js'

export default {
  props: {
    Onboarding_action: {
      type: Boolean,
      default: () => ''
    },
    show_activebtnPage: {
      type: Boolean,
      default: () => false
    },
    show_noconnection: {
      type: Boolean,
      default: () => false
    },
    closeOnboarding: {
      type: Function,
      required: true
    }
  },
  methods: {
    // showOnboarding_(){
    //   this.$emit("showOnboarding", "")
    // }
    // 執行手機版網頁檢查，是的話更改isEipMobileWeb狀態
    // isEipMobile() {
    //   let webPathname = window.location.pathname
    //   console.log(webPathname)
    //   this.isEipMobileWeb = webPathname.includes('/m')
    // }
  },
  mounted() {
    // 判斷是否在聯8達專案，執行手機版網頁檢查
    // if(this.$route.params.projectId === 'eip') {
    //   console.log('eip')
    //   this.isEipMobile()
    // }
    // 接收isEipMobileWeb資料
    EventBus.$on('receive',({isEipMobileWeb})=>{
      this.isEipMobileWeb = isEipMobileWeb
    })
    
  },
  data() {
    return {
      // immediacy_time: 0
      isEipMobileWeb: false
    }
  }
}
</script>
<style scoped>
@import "./styles/onboarding.css";
@import "./styles/header.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/Onboarding.vue